'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:train:vibrate');
}

var _invoke = require('../invoke');

/**
 *
 * @memberof train
 * @static
 * @name vibrate
 * @param {Number} duration 震动时长
 * @return {Promise}
 * @example
 *  hbnb.train.vibrate(1000)
 *      .then(function() {});
 */
module.exports = function(duration) {
    if (process.env.NODE_ENV !== 'production') {
        debug('duration is %s', duration);
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('train', 'vibrate', {
            duration: duration,
            callback: function() {
                resolve();
            },
            errback: function() {
                reject();
            }
        });
    });

    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/train/vibrate.js
// module id = 640
// module chunks = 0